<div class="app-shell flex-column">
  <header class="fds-page-header-root">
    <div class="fds-page-header__logo">
      <fds-link class="fds-page-header__link" fds-href="/">
        <img [src]="fundsNetworkLogoSrc" alt="FundsNetwork Logo" height="30" />
      </fds-link>
    </div>
  </header>

  <div class="flex-column overflow flex-grow">
    <main class="flex-grow" [class.main-public-layout]="shellMainNoPadding">
      <router-outlet />
    </main>

    <footer class="fds-page-footer-root">
      <div class="fds-page-footer__logo" aria-hidden="true">
        <img [src]="fidelityLogoSrc" alt="Fidelity Logo" height="50" />
      </div>
      <div class="fds-page-footer__content">
        <p class="fds-page-footer__copyright">
          {{ copyright }}
        </p>
        <div class="fds-page-footer__links">
          <fds-link
            class="fds-page-footer__link-spacer"
            fds-href="https://www.fidelity.com/"
            fds-new-window
            >Personal Investing</fds-link
          >
          <fds-link
            class="fds-page-footer__link-spacer"
            fds-href="https://clearingcustody.fidelity.com/app/home"
            fds-new-window
            >Fidelity Custody & Clearing Solutions&reg;</fds-link
          >
          <fds-link
            class="fds-page-footer__link-spacer"
            fds-href="https://workplace.fidelity.com/"
            fds-new-window
            >Workplace Investing</fds-link
          >
          <fds-link fds-new-window [attr.fds-href]="publicUserAgreementPath"
            >User Agreement</fds-link
          >
        </div>
        <p class="fds-page-footer__user-reference">
          {{ userReference }}
        </p>
      </div>
    </footer>
  </div>
</div>
